import React from 'react';
import SVGLoader from './SVGLoader';

const defaults = {
  viewboxHeight: 12,
  viewboxWidth: 12,
};

export default ({
  viewboxWidth = defaults.viewboxWidth,
  viewboxHeight = defaults.viewboxHeight,
  ...rest
}) => (
  <SVGLoader
    viewboxHeight={viewboxHeight}
    viewboxWidth={viewboxWidth}
    {...rest}
  >
    <path d="M6 0C4.81331 0 3.65328 0.351894 2.66658 1.01118C1.67989 1.67047 0.910851 2.60754 0.456726 3.7039C0.00259972 4.80026 -0.11622 6.00666 0.115291 7.17054C0.346802 8.33443 0.918247 9.40353 1.75736 10.2426C2.59648 11.0818 3.66558 11.6532 4.82946 11.8847C5.99335 12.1162 7.19975 11.9974 8.2961 11.5433C9.39246 11.0892 10.3295 10.3201 10.9888 9.33342C11.6481 8.34673 12 7.18669 12 6C12 4.4087 11.3679 2.88258 10.2426 1.75736C9.11742 0.632141 7.5913 0 6 0V0ZM7.25 9.065C7.25586 9.10036 7.25388 9.13657 7.24422 9.17108C7.23456 9.20559 7.21744 9.23756 7.19408 9.26473C7.17072 9.29191 7.14168 9.31363 7.10901 9.32836C7.07634 9.3431 7.04084 9.35048 7.005 9.35H4.855C4.81815 9.35078 4.7816 9.34323 4.74808 9.32792C4.71455 9.31261 4.68491 9.28994 4.66136 9.26159C4.63781 9.23323 4.62096 9.19993 4.61207 9.16416C4.60318 9.12839 4.60247 9.09108 4.61 9.055L5.24 6.125C4.91657 5.97355 4.64849 5.72491 4.47317 5.41377C4.29785 5.10264 4.22403 4.74453 4.26202 4.38943C4.30001 4.03432 4.44791 3.69993 4.68508 3.43292C4.92225 3.16592 5.23686 2.97961 5.585 2.9C5.84059 2.8366 6.10722 2.83188 6.36489 2.88617C6.62257 2.94047 6.86462 3.05238 7.0729 3.21352C7.28117 3.37465 7.45028 3.58084 7.56754 3.81663C7.68481 4.05241 7.74718 4.31168 7.75 4.575C7.74711 4.90152 7.6516 5.22051 7.47458 5.49489C7.29756 5.76927 7.0463 5.98778 6.75 6.125L7.25 9.065Z" />
  </SVGLoader>
);
